export const environment = {
    production: true,
    hmr       : false,
    apiUrl    : 'https://gateway.la-mira.com',
};



// WEBPACK FOOTER //
// /usr/app/src/environments/environment.ts